import { useMemo } from 'react';

import { sanitizeUrlOrUrlPath } from '../sanitizeUrlOrUrlPath.util';

export type UseSanitizedUrlOrUrlPathProps = {
  urlOrUrlPath: undefined | null | string;
};

export const useSanitizedUrlOrUrlPath = ({
  urlOrUrlPath,
}: UseSanitizedUrlOrUrlPathProps) => {
  const returnValue = useMemo(
    () => ({
      sanitizedUrlOrUrlPath: sanitizeUrlOrUrlPath(urlOrUrlPath),
    }),
    [urlOrUrlPath],
  );

  return returnValue;
};
